/*eslint-env jquery*/
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import Select from 'react-select'
import { usersService } from '../../_services/users.service'
import userTypes from '../../_constants/userTypes'
import UserTypeSelect from '../Shared/UserTypeSelect'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from "react-table"

import { Input } from 'antd'
import { FaPlus } from 'react-icons/fa'
import { FiEdit, FiCheckCircle, FiCircle } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'

class Users extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      data: [],
      loading: true,
      confirmDeleteShow: false,
      requiredItem: 0,
      deleteItemIndex: 0,
      model: {},
      pageSize: 10,
    }

    this.getData()
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false });
  }

  getData() {
    usersService.getAll()
      .then((res) => {
        // console.log(res.data)
        let pageSize = res.data.length;
        this.setState({ data: res.data, pageSize: pageSize, loading: false });
      })
  };

  handleError(error) {
    this.setState({ loading: false });
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = (e) => {
    let _model = this.state.data[e];
    // console.log(_model);

    this.setState({ confirmDeleteShow: true, model: _model });
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false });
    // // console.log(this.state.model );
    usersService.delete(this.state.model.id)
      .then((res) => {
        toastr.success('حذف کاربر ', 'کاربر با موفقیت حذف شد');
        this.getData();
      })
      .catch((error) => {
        this.handleError(error)
      });
  }

  render() {
    const { data, pageSize } = this.state;
    return (
      <div>
        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            data={data}
            filterable

            previousText='صفحه قبل'
            nextText='صفحه بعد'
            loadingText='در حال بارگذاری ...'
            noDataText='نتیجه ای یافت نشد'
            pageText='صفحه'
            ofText='از'
            rowsText='تعداد نمایش'
            getTableProps={() => ({ style: { display: 'block' } })} // direction: rtl fix

            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: "ردیف",
                id: "row",
                maxWidth: 50,
                filterable: false,
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                className: "numberFa",
                Cell: (row) => {
                  return row.index + 1;
                }
              },
              {
                Header: "نوع کاربر",
                accessor: "userType",
                id: "userType",
                style: { display: 'flex', alignItems: 'center', overflow: 'visible', justifyContent: 'center' },

                filterMethod: (filter, row) => {

                  if (filter.value === null || filter.value === undefined) {
                    return true;
                  }
                  if (row[filter.id] === filter.value.value) {
                    return true;
                  }
                  // // console.log(filter);
                  //return row[filter.id] === filter.value;
                },
                Cell: row => (
                  userTypes.filter(el => el.value === row.original.userType)[0].label
                ),
                Filter: ({ onChange }) =>
                  <UserTypeSelect isClearable
                    placeholder=''
                    onChange={event => onChange(event)}
                  />
              },
              {
                Header: "نام و نام خانوادگی",
                accessor: "fullName",
                id: "fullName",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["fullName"] }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "ایمیل",
                accessor: "email",
                id: "email",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["email"] }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "شماره موبایل",
                accessor: "mobile",
                id: "mobile",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                className: "numberFa",
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["mobile"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              // {
              //   Header: "کد فعال سازی",
              //   accessor: "activationCode",
              //   id: "activationCode",
              //   style: { display: 'flex', alignItems: 'center', overflow: 'visible', justifyContent: 'center' },
              //   filterable: false,
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["user.activationCode"], threshold: matchSorter.rankings.CONTAINS }),
              //   filterAll: true,
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,

              //   Cell: row => (
              //     row.original.activationCode
              //   )
              // },
              {
                Header: "وضعیت",
                accessor: d => d.status,
                id: "status",
                sortable: false,
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                width: 140,
                Cell: row => (
                  <div>
                    {row.original.status ? <FiCheckCircle size="24px" color="#4caf50" /> : <FiCircle size="24px" color="#f44336" />}
                  </div>
                ),
                filterMethod: (filter, row) => {

                  if (filter.value === null || filter.value === undefined) {
                    return true;
                  }
                  if (filter.value.value === 0) {
                    return row.status === filter.value.value
                  }
                  return row.status > 0

                },
                Filter: ({ onChange }) =>
                  <Select isClearable
                    placeholder=""
                    options={[
                      { value: 1, label: 'فعال' },
                      { value: 0, label: 'غیر فعال' },
                    ]}

                    onChange={event => onChange(event)}
                  />
              },
              {
                Header: "ویرایش",
                accessor: 'id',
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                sortable: false,
                Filter: ({ filter, onChange }) =>
                  <Link to="/admin/users/new" className="btn btn-primary react-table-add-btn">
                    <span>
                      <FaPlus size="16px" />
                      <span>افزودن کاربر جدید</span>
                    </span>
                  </Link>,
                Cell: row => (
                  <div>
                    <Link
                      // disabled={row.original.userType === 0}
                      to={
                        //  row.original.userType === 0 ? '/admin/users/' : 
                        '/admin/users/' + row.original.id + '/edit'} params={{ id: row.original.id }} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><FiEdit size="24px" /></Link>
                    <a onClick={() => this.handleDelete(row.index)} className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn" data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a>
                  </div>
                )
              }
            ]}
            defaultPageSize={10}
            pageSize={pageSize}
            className="-striped -highlight"
          >
            {(state, makeTable, instance) => {
              let recordsInfoText = "";

              const { filtered, pageRows, pageSize, sortedData, page, data } = state;

              if (sortedData && sortedData.length > 0) {
                let isFiltered = filtered.length > 0;

                let totalRecords = sortedData.length;

                let totalDataCount = data.length;

                let recordsCountFrom = page * pageSize + 1;

                let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                if (isFiltered)
                  recordsInfoText = `${totalRecords} از ${totalDataCount} نتیجه فیلتر شده`;
                else
                  recordsInfoText = `تعداد کل: ${totalRecords}`;
              } else recordsInfoText = "نتیجه ای یافت نشد";

              return (
                <>
                  <div className="row text-right">
                    <div className="col-sm-12">
                      <span className="records-info">{recordsInfoText}</span>
                    </div>
                    <br />
                    <br />
                  </div>
                  {makeTable()}
                </>
              );
            }}
          </ReactTable>

        </div>

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={"آیا از حذف کاربر  " + (this.state.model.firstName ? this.state.model.firstName : '') + ' ' + (this.state.model.lastName ? this.state.model.lastName : '') + " مطمئن هستید؟"}
        >
        </MySweetAlert>

        {this.state.loading ? <Loading /> : ''}
      </div>
    );
  }
}

export default Users;
